import { i18n } from '@aqx-core/common/i18n';

export const formatCooldown = (seconds?: number) => {
  if (!seconds || seconds <= 0) {
    return '';
  }

  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  const units = [
    {
      val: d,
      render: (c: number) =>
        c === 1 ? i18n.t('{{countdown}} day', { countdown: c }) : i18n.t('{{countdown}} days', { countdown: c })
    },
    {
      val: h,
      render: (c: number) =>
        c === 1 ? i18n.t('{{countdown}} hour', { countdown: c }) : i18n.t('{{countdown}} hours', { countdown: c })
    },
    {
      val: m,
      render: (c: number) =>
        c === 1 ? i18n.t('{{countdown}} minute', { countdown: c }) : i18n.t('{{countdown}} minutes', { countdown: c })
    },
    {
      val: s,
      render: (c: number) =>
        c === 1 ? i18n.t('{{countdown}} second', { countdown: c }) : i18n.t('{{countdown}} seconds', { countdown: c })
    }
  ];

  return units
    .filter((unit) => unit.val > 0)
    .map((unit) => unit.render(unit.val))
    .join(' ');
};
